import { useState, useEffect } from 'react';
import { AuthService } from 'services/AuthService';

export function useAuthListener(authService: AuthService | null) {
  const [isAuthenticated, setIsAuthenticated] = useState(
    authService?.isAuthenticated() ?? false,
  );

  useEffect(() => {
    if (!authService) return;

    setIsAuthenticated(authService.isAuthenticated());

    const unsubscribe = authService.onAuthStateChanged(isAuth => {
      setIsAuthenticated(isAuth);
    });

    return () => {
      unsubscribe();
    };
  }, [authService]);

  return isAuthenticated;
}
